// @ts-nocheck
import{useEffect,useState}from"react"
import{useParams,Link,useNavigate}from"react-router-dom"
import{motion}from"framer-motion"
import{supabaseClient}from"@/lib/supabase/client"
import{useAuth}from"@/components/layout/AuthProvider"
import{PostCard}from"@/components/post/PostCard"

export default function ProfilePage(){
const{username}=useParams()
const{supabaseUser,user:me}=useAuth()
const[profile,setProfile]=useState<any>(null)
const[posts,setPosts]=useState<any[]>([])
const[loading,setLoading]=useState(true)
const[following,setFollowing]=useState(false)

useEffect(()=>{
if(!username)return
supabaseClient.from("users").select("*").eq("username",username).single()
.then(({data})=>{
setProfile(data)
if(data){
supabaseClient.from("posts")
.select("*,users!posts_author_id_fkey(id,username,display_name,avatar_url,is_verified),post_topics(topics(id,name,slug))")
.eq("author_id",data.id).eq("status","published")
.order("created_at",{ascending:false}).limit(20)
.then(({data:pd})=>{setPosts((pd||[]).map((p:any)=>({...p,author:p.users,topic:p.post_topics?.[0]?.topics})));setLoading(false)})
}else setLoading(false)
})
},[username])

useEffect(()=>{
if(!supabaseUser||!profile)return
supabaseClient.from("follows").select("id").eq("follower_id",supabaseUser.id).eq("following_id",profile.id)
.then(({data})=>setFollowing((data||[]).length>0))
},[supabaseUser?.id,profile?.id])

const handleFollow=async()=>{
if(!supabaseUser||!profile)return
if(following){await supabaseClient.from("follows").delete().eq("follower_id",supabaseUser.id).eq("following_id",profile.id);setFollowing(false)}
else{await supabaseClient.from("follows").insert({follower_id:supabaseUser.id,following_id:profile.id} as any);setFollowing(true)}
}

if(loading)return <div style={{padding:"2rem 1rem"}}><div className="skeleton h-40 rounded-xl mb-3"/><div className="skeleton h-64 rounded"/></div>
if(!profile)return <div style={{padding:"4rem 1rem",textAlign:"center"}}><p className="font-outfit font-bold text-xl">User not found</p></div>

const isOwner=supabaseUser?.id===profile.id
const joinDate=new Date(profile.joined_at||profile.created_at).toLocaleDateString("en-ZA",{month:"short",year:"numeric"})

return(
<div style={{maxWidth:860,margin:"0 auto",paddingBottom:"5rem"}}>
  <motion.div initial={{opacity:0}} animate={{opacity:1}}>
    <div className="sq-panel mb-3 overflow-hidden">
      <div className="relative">
        <div className="w-full h-32 sm:h-44 overflow-hidden" style={{background:"linear-gradient(135deg,#1a0a00,#0a0005)"}}>
          {profile.banner_url&&<img src={profile.banner_url} alt="Banner" className="w-full h-full object-cover"/>}
        </div>
        <div className="absolute" style={{bottom:"-2rem",left:"1rem"}}>
          <div className="rounded-full overflow-hidden border-4" style={{width:72,height:72,borderColor:"var(--bg2)",background:"var(--bg3)"}}>
            {profile.avatar_url?<img src={profile.avatar_url} alt={profile.display_name} className="w-full h-full object-cover"/>:
              <div className="w-full h-full flex items-center justify-center font-outfit font-black text-2xl" style={{color:"var(--brand)"}}>{(profile.display_name||"?")[0].toUpperCase()}</div>}
          </div>
        </div>
      </div>
      <div style={{paddingTop:"2.5rem",padding:"2.5rem 1rem 1rem"}}>
        <div className="flex items-start justify-between gap-3 flex-wrap">
          <div>
            <h1 className="font-outfit font-bold text-xl leading-none mb-0.5">{profile.display_name}</h1>
            <p className="text-sm" style={{color:"var(--text2)"}}>u/{profile.username}</p>
            {profile.bio&&<p className="text-sm mt-2" style={{maxWidth:480,color:"var(--text2)"}}>{profile.bio}</p>}
          </div>
          <div className="flex gap-2 flex-shrink-0">
            {isOwner?<Link to="/settings" className="sq-btn sq-btn-outline text-xs px-4 py-1.5">Edit Profile</Link>:
            supabaseUser?<button onClick={handleFollow} className={`sq-btn text-xs px-4 py-1.5 ${following?"sq-btn-outline":"sq-btn-primary"}`}>{following?"Following":"Follow"}</button>:null}
          </div>
        </div>
        <div className="flex gap-4 mt-3" style={{flexWrap:"wrap"}}>
          {[["Karma",(profile.karma_score||0).toLocaleString()],["Posts",profile.post_count||0],["Followers",profile.follower_count||0],["Joined",joinDate]].map(([l,v])=>(
            <div key={l}><span className="font-bold text-sm">{v}</span><span className="text-xs ml-1" style={{color:"var(--text3)"}}>{l}</span></div>
          ))}
        </div>
      </div>
    </div>

    <h2 className="font-outfit font-bold text-sm uppercase tracking-wider mb-2 px-1" style={{color:"var(--text3)"}}>Posts</h2>
    {posts.length===0?<div className="sq-panel p-10 text-center text-sm" style={{color:"var(--text3)"}}>No posts yet.</div>:
    <div className="space-y-2">{posts.map(p=><PostCard key={p.id} post={p} userId={supabaseUser?.id||null}/>)}</div>}
  </motion.div>
</div>
)
}
